import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M15 7h4v10h-4z",
  opacity: ".3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3 13h8v2H3zm0 4h8v2H3zm0-8h8v2H3zm0-4h8v2H3zm10 0v14h8V5h-8zm6 12h-4V7h4v10z"
})), 'VerticalSplitTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/VerticalSplitTwoTone.js
// module id = 7029
// module chunks = 2